// L I B R A R I E S
import React from 'react';

// C O M P O N E N T S 
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';

// A S S E T S
import './App.css';   
import LanguageHome from './components/LanguageHome';
import Grammar from './components/Grammar';
import Chat from './components/Chat';
import TaskReview from './components/TaskReview';
import CourseActivity from './components/CourseActivity';
import {
  replaceWithSession,
} from './services/sessionNavigation';

function HardRedirect({
  to,
}: {
  to: string;
}) {
  React.useEffect(() => {
    replaceWithSession(to);
  }, [to]);

  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HardRedirect to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/login/french" element={<HardRedirect to="/login?language=french" />} />
        <Route path="/login/german" element={<HardRedirect to="/login?language=german" />} />
        <Route path="/login/english" element={<HardRedirect to="/login?language=english" />} />
        <Route path="/taskreviewer/english" element={<HardRedirect to="/login?language=english_taskreviewer" />} />
        <Route path="/taskreviewer/french" element={<HardRedirect to="/login?language=french_taskreviewer" />} />
        <Route path="/taskreviewer/german" element={<HardRedirect to="/login?language=german_taskreviewer" />} />
        <Route path="/language" element={<LanguageHome />} />
        <Route path="/chat" element={<Chat />}/>
        <Route path="/grammar" element={<Grammar />}/>
        <Route path="/taskreviewer" element={<TaskReview />}/>
        <Route path="/course-activity" element={<CourseActivity />}/>
      </Routes>
    </Router>
  );
}

export default App;
